
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rides",
      function () {
        return require("private-next-pages/rides/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rides"])
      });
    }
  